import { dbiPageLogMes } from '@/pages/intelligence/utils/buriedPointCfg';
import moment from 'moment';
import { DisableType } from '@/pages/intelligence/pages/Following/_hook/useFollowingOptionList';
import { LANGUAGE_CN } from '@/pages/home/_config/config';
import {
  fetchFollowingCurrentGamesMobile,
  fetchFollowingCurrentGamesPCConsole,
  fetchFollowingCurrentGamesCompany,
  // fetchFollowingCurrentGamesMobileTrend,
  fetchFollowingCurrentGamesPCConsoleTrend,
  fetchFollowingCurrentGamesCompanyTrend,
  fetchFollowingCurrentGamesMobileTrendNew,
} from '@/pages/intelligence/services/following';
import { financeFormat } from '@/pages/home/utils/common';


export const fetchFunctionsByEntityType = {
  pc: fetchFollowingCurrentGamesPCConsole,
  console: fetchFollowingCurrentGamesPCConsole,
  company: fetchFollowingCurrentGamesCompany,
  mobile: fetchFollowingCurrentGamesMobile,
} as any;

export const fetchTrendFunctionsByEntityType = {
  pc: fetchFollowingCurrentGamesPCConsoleTrend,
  console: fetchFollowingCurrentGamesPCConsoleTrend,
  company: fetchFollowingCurrentGamesCompanyTrend,
  mobile: fetchFollowingCurrentGamesMobileTrendNew,
} as any;


const followingTabMapping = {
  currentgames: {
    mobile: dbiPageLogMes.followingCurrentGamesMobile,
    pc: dbiPageLogMes.followingCurrentGamesPC,
    console: dbiPageLogMes.followingCurrentGamesConsole,
    company: dbiPageLogMes.followingCurrentGamesCompanies,
  },
  newgames: {
    mobile: dbiPageLogMes.followingNewGamesMobile,
    pc: dbiPageLogMes.followingNewGamesPC,
    console: dbiPageLogMes.followingNewGamesConsole,
  },
  manage: {
    mobile: dbiPageLogMes.followingManageMobile,
    pc: dbiPageLogMes.followingManagePC,
    console: dbiPageLogMes.followingManageConsole,
    company: dbiPageLogMes.followingManageCompanies,
  },
} as any;

export const getFollwingPageLogMes = (entityType: string, tab: string) => {
  return followingTabMapping[tab]?.[entityType] || null;
};

export const getDefaultGenreParams = (entityType: string) => {
  if (entityType === 'mobile') {
    return {
      genre: [],
      sub_genre: [],
    };
  } else if (entityType === 'pc' || entityType === 'console') {
    return {
      iegg_genre_req: [],
      genre_source: 'iegg',
    };
  }
  //company
  return {};
};

export const isSingleMonthGranularity = (dateType: string, startDate: string, endDate: string) => {
  const timeIsNull = !startDate || !endDate;
  const isSingleMonth = timeIsNull ? false : dateType === 'monthly' && moment(startDate).isSame(moment(endDate), 'month');
  return isSingleMonth
}

/**
 * 单月选择时，趋势线图的 start_date 需往前推5个月。
 * 例如选6月，start_date 调整为1月，end_date 保持6月不变。
 */
export const getTrendAdjustedStartDate = (dateType: string, startDate: string, endDate: string) => {
  if (isSingleMonthGranularity(dateType, startDate, endDate)) {
    return moment(startDate).subtract(5, 'months').format('YYYY-MM-DD');
  }
  return startDate;
}

export const isMetricDisabled = (params: any): boolean => {
  const { dateType, startDate, endDate, markets, disableType } = params || {};
  const timeIsNull = !startDate || !endDate;
  //单国家
  const hasSingleMarket = markets?.length === 1 && markets[0] !== 'global';
  //单天
  const isSameDay = timeIsNull ? false : dateType === 'daily' && startDate === endDate;
  //单月
  // const isSingleMonth = timeIsNull ? false : dateType === 'monthly' && moment(startDate).isSame(moment(endDate), 'month');
  const isSingleMonth = isSingleMonthGranularity(dateType, startDate, endDate,)

  switch (disableType) {
    case DisableType.SIMDATE_SIMMARKET:
      return !(isSameDay && hasSingleMarket);
    case DisableType.SIMDATE_GLOBAL:
      return !(isSameDay && markets?.[0] === 'global');
    case DisableType.SIMMONTH:
      return !isSingleMonth;
    case DisableType.ONLYMONTH:
      return !(dateType === 'monthly');
    case DisableType.GLOBAL_ONLY:
      return markets[0] !== 'global';
    case DisableType.FAMITSU:
      //famitsu指标： (japan) && weekly
      return !(markets?.includes('jp') && (dateType === 'weekly'));
    default:
      return false;
  }
};

export const FOLLOWING_RETENTION_METRIC_KEYS = [
  'appannie_retention',
  'sensortower_retention',
] as const;

export const FOLLOWING_ST_RETENTION_METRIC_KEY = 'sensortower_retention';

export const isFollowingRetentionMetricKey = (key: string) =>
  (FOLLOWING_RETENTION_METRIC_KEYS as readonly string[]).includes(key);

/** Reviews tab 可展示的原指标及本次新增的四个 Reviews 指标；Players 指标不纳入。 */
const FOLLOWING_REVIEW_METRIC_KEYS = [
  'alinea_alinea__steamreviews',
  'gamalytic_gamalytic__cumulative_reviews',
  'alinea_alinea__cumulative_reviews',
  'alinea_alinea__positive',
  'alinea_alinea__cumulative_positive',
];

/** 保留现有 tab key，避免影响 tab 状态与详情跳转。 */
export const FOLLOWING_REVIEW_CHART_SEGMENT_KEY = 'alinea_alinea__steamreviews';

/**
 * 选择器可能同时勾选多个 Reviews 指标，按列表末尾优先使用用户最后选中的指标。
 */
export const getFollowingReviewMetric = (selectedMetrics: string[] = []) =>
  [...selectedMetrics].reverse().find(metric => FOLLOWING_REVIEW_METRIC_KEYS.includes(metric)) || '';

export const getSelectedFollowingRetentionMetrics = (metrics: string[]) =>
  FOLLOWING_RETENTION_METRIC_KEYS.filter(key => metrics?.includes(key));

export const FOLLOWING_RETENTION_DN_METRICS = [
  'D2',
  'D3',
  'D7',
  'D15',
  'D31',
] as const;

const FOLLOWING_RETENTION_SOURCE_PREFIX: Record<string, string> = {
  appannie_retention: 'appannie',
  sensortower_retention: 'sensortower',
};

export const getFollowingRetentionSourcePrefix = (metricKey: string) =>
  FOLLOWING_RETENTION_SOURCE_PREFIX[metricKey] || '';

/** Retention 子页签 Dn 对应的 trend 指标 key，如 appannie_D7 / sensortower_D7 */
export const getFollowingRetentionDnMetricKey = (
  retentionMetricKey: string,
  dn: string,
) => `${getFollowingRetentionSourcePrefix(retentionMetricKey)}_${dn}`;

export const hasFollowingRetentionInSourceMetric = (
  sourceMetric?: Record<string, string[]>,
) =>
  sourceMetric?.appannie?.includes('retention') ||
  sourceMetric?.sensortower?.includes('retention');

/** 下载弹窗：优先看页面 metrics 勾选，兼容 source_metric */
export const hasFollowingRetentionForDownload = (
  metrics?: string[],
  sourceMetric?: Record<string, string[]>,
) =>
  getSelectedFollowingRetentionMetrics(metrics || []).length > 0 ||
  hasFollowingRetentionInSourceMetric(sourceMetric);

/** 图表 Retention segment 当前应对应的 metric key（ST 优先） */
export const getActiveFollowingRetentionMetric = (metrics: string[] = []) =>
  metrics.includes(FOLLOWING_ST_RETENTION_METRIC_KEY)
    ? FOLLOWING_ST_RETENTION_METRIC_KEY
    : FOLLOWING_RETENTION_METRIC_KEYS[0];

const FOLLOWING_DUAL_SOURCE_CHART_SEGMENTS = ['dau', 'revenue', 'download'] as const;

/** 折线图 trend 接口：根据图表 segment 与已勾选 metrics 解析 source_metric 所需的 metric 配置项 */
export const getFollowingTrendSegmentItems = (
  chartSegment: string,
  metricList: any[],
  selectedMetrics: string[] = [],
) => {
  if (!Array.isArray(metricList) || metricList.length === 0) {
    return [];
  }
  if (isFollowingRetentionMetricKey(chartSegment)) {
    const selectedRetentionMetrics = getSelectedFollowingRetentionMetrics(selectedMetrics);
    const retentionKeys =
      selectedRetentionMetrics.length > 0
        ? selectedRetentionMetrics
        : [FOLLOWING_RETENTION_METRIC_KEYS[0]];
    return metricList.filter((t: any) => retentionKeys.includes(t?.key));
  }
  if (chartSegment === FOLLOWING_REVIEW_CHART_SEGMENT_KEY) {
    const reviewMetric = getFollowingReviewMetric(selectedMetrics);
    return metricList.filter((t: any) => t?.key === reviewMetric);
  }
  if (
    (FOLLOWING_DUAL_SOURCE_CHART_SEGMENTS as readonly string[]).includes(chartSegment)
  ) {
    return metricList.filter((t: any) => {
      if (!selectedMetrics.includes(t?.key)) {
        return false;
      }
      return (
        t?.key === chartSegment ||
        t?.key === `appannie_${chartSegment}` ||
        t?.key === `sensortower_${chartSegment}`
      );
    });
  }
  return metricList.filter(
    (t: any) => t?.key === chartSegment && selectedMetrics.includes(t?.key),
  );
};

/**如果标签值不存在metric筛选器指标勾选的值则禁用 */
export const checkAvailability = (availableValues: string[], value: string) => {
  if (!Array.isArray(availableValues)) {
    return false;
  }
  if (isFollowingRetentionMetricKey(value)) {
    return FOLLOWING_RETENTION_METRIC_KEYS.some(metric =>
      availableValues.includes(metric),
    );
  }
  const prefixes = ['appannie_', 'sensortower_', ''];//''是兼容company的revenue等值
  if (['dau', 'revenue', 'download'].includes(value)) {
    return prefixes.some((prefix) =>
      availableValues.includes(prefix + value),
    );
  }

  /** Reviews tab 是类别 tab：勾选任意 Reviews 指标即可启用。 */
  if (value === FOLLOWING_REVIEW_CHART_SEGMENT_KEY) {
    return availableValues.some(metric => FOLLOWING_REVIEW_METRIC_KEYS.includes(metric));
  }
  
  // 支持 Gamalytic 指标：检查是否有 gamalytic_gamalytic__XXX 或 vginsights_XXX 或 steamcharts_XXX
  // value 可能是 gamalytic__pcu, gamalytic__steamfollowers, gamalytic__steamreviews
  if (value.startsWith('gamalytic__')) {
    // 对于 gamalytic__pcu 等，检查是否存在 gamalytic_gamalytic__pcu 或 steamcharts_pcu
    const gamalyticKey = `gamalytic_${value}`;
    const baseMetric = value.replace('gamalytic__', '');
    const vgiKey = `vginsights_${baseMetric}`;
    const steamchartsKey = `steamcharts_${baseMetric}`;
    return availableValues.includes(gamalyticKey) || 
           availableValues.includes(vgiKey) || 
           availableValues.includes(steamchartsKey);
  }
  
  return availableValues.includes(value);
};

// export const handleRetentionMetrics = (metrics: string[]) => {
//   const replacementValues = ['D2', 'D3', 'D7', 'D15', 'D31'];
//   const newMetrics = metrics?.flatMap(value => {
//     if (value === "appannie_retention") {
//       return replacementValues;
//     } else {
//       return value;
//     }
//   });
//   return newMetrics;
// }

//TODO 跳转
// 全局级别定义tab和subTab的匹配对象
export const DETAIL_PAGE_TAB_MSG = {
  au: ['stats', 'activeusers'],
  rev: ['stats', 'revenue'],
  dls: ['stats', 'downloads'],
  retention: ['stats', 'retention_monthly'],
  appannie_retention: ['stats', 'retention_monthly'],
  sensortower_retention: ['stats', 'retention_monthly'],
  stream_hours_watched: ['streaming', 'hoursWatched'],
  hours_watched: ['streaming', 'hoursWatched'],
  stream_peak_ccv: ['streaming', 'peackCCV'],
  peak_ccv: ['streaming', 'peackCCV'],
  pcu: ['stats', 'pcu'],
  digital_revenue: ['stats', 'digitalRevenue'],
  revenue: ['Summary', 'revenue'],//company的
  download: ['Summary', 'revenue'],//company的
} as any;

/**device参数特殊处理传到后端 */
export const getDeviceParams = (deviceValues: string[]) => {
  const platforms = {
    'PlayStation': {
      npd: ["PlayStation 4", "PlayStation 5"],
      mscience: ["playstation store"],
      famitsu: ["ps5", "ps4"]
    },
    'Xbox': {
      npd: ["Xbox One", "Xbox Series X|S"],
      mscience: ["microsoft store"],
      famitsu: []
    },
    'Nintendo': {
      npd: ["Nintendo Wii U", "Nintendo Switch"],
      famitsu: ["switch"],
      mscience: ["nintendo eshop"],
    }
  } as any

  let device: {
    npd: string[];
    mscience: string[];
    famitsu: string[];
  } = {
    npd: [], mscience: [], famitsu: []
  }
  let selectDevice = deviceValues;
  if (!deviceValues?.length || deviceValues?.includes('All')) {
    selectDevice = ['PlayStation', 'Xbox', 'Nintendo'];
  }

  Object.keys(platforms).forEach(platform => {
    if (selectDevice?.includes(platform)) {
      device.npd.push(...platforms[platform].npd)
      device.mscience.push(...platforms[platform].mscience)
      device.famitsu.push(...platforms[platform].famitsu)
    }
  })
  return device;
}

/**新BigQuery-mobile参数特殊处理传到后端 */
export const getBigQueryTableParams = (sourceList: any[], metricName = 'value', dataSourceName = 'apiSource') => {
  let sourceObj: any = {};

  if (Array.isArray(sourceList) && sourceList?.length > 0) {
    sourceList?.forEach((item: any) => {
      let apiSource = item?.[dataSourceName];
      if (apiSource){
        //在数据源为 "appannie,sensortower" 时进行特殊的拆分处理
        let dataSourceList = apiSource === 'appannie,sensortower' ? ['appannie','sensortower'] : [apiSource];

        dataSourceList?.forEach((source: string) => {
          if (sourceObj.hasOwnProperty(source)) {
            sourceObj[source].push(item?.[metricName]);
            if(source === 'vginsights' && item?.[metricName] === 'est_price'){
              sourceObj[source].push('est_price_time')
            }
          } else {
            sourceObj[source] = [item?.[metricName]];
            if(source === 'vginsights' && item?.[metricName] === 'est_price'){
              sourceObj[source].push('est_price_time')
            }
          } 
        })
      }
    });
  }
  return sourceObj;
}
/**新BigQuery-mobile参数特殊处理传到后端--折线图 */
export const getBigQueryTrendSourceMetricParams = (sourceList:  any[], metricName = 'value', dataSourceName = 'apiSource') => {
  let sourceObj: any = {};
  if (Array.isArray(sourceList) && sourceList?.length > 0) {
    sourceList?.forEach((item: any) => {
      let apiSource = item?.[dataSourceName];
      if (apiSource) {
        //在数据源为 "appannie,sensortower" 时进行特殊的拆分处理
        let dataSourceList = apiSource === 'appannie,sensortower' ? ['appannie', 'sensortower'] : [apiSource];
        dataSourceList?.forEach((source: string) => {
          sourceObj[source] = item?.[metricName];
        })
      }
    });
  }
  return sourceObj;
}


export const createDataSourceMetricForValue = (metric: string, apiSource?: string) => {
  if (typeof metric !== 'string') {
    return ''
  }
  if (apiSource) {
    return apiSource + '_' + metric?.replace(/\s*/g, '')
  }
  return metric?.replace(/\s*/g, '')
}

/**新BigQuery-mobile-返回metric拼接唯一key */
// export const getBigQueryMobileMetrics = (tableList: any[]) => {
//   let metricListTemp: any = [];
//   if (Array.isArray(tableList) && tableList?.length > 0) {
//     tableList?.forEach((item: any) => {
//       let metricArr: any = [];
//       if (Array.isArray(item.metric_list) && item.metric_list?.length > 0) {
//         item.metric_list?.forEach((subItem: any) => {
//           metricArr.push({
//             ...subItem,
//             // metric: item.data_source + item.metric.replace(/\s*/g, '')
//             metric: subItem.key
//           })
//         });
//       }

//       metricListTemp.push({
//         ...item,
//         metric_list: metricArr
//       })
//     });
//   }
//   return metricListTemp;
// }



export const getLeftCellTitle = (entityType: string) => {
  switch (entityType) {
    case 'mobile':
      return 'dbi_top10_revenue'
    case 'pc':
    case 'console':
      return 'dbi_top10_digital'
    case 'company':
      return 'dbi_top10_sum_rev'
    default:
      return ''
  }
}

export const getFollowingMetricListWidth = (entityType: string, locale: string) => {
  if (entityType === 'console') {
    return locale === LANGUAGE_CN ? 272 : 372;
  }
  if (entityType === 'pc') {
    return locale === LANGUAGE_CN ? 250 : 276;
  }
  return 250
}


//TODO retention不需要展示data.ai
export function getTitleFromMetric(metric: string) {
  const showMetricsItemList = [
    'appannie_dau',
    'appannie_revenue',
    'appannie_download',
    'appannie_retention',
    'appannie_D2',
    'appannie_D3',
    'appannie_D7',
    'appannie_D15',
    'appannie_D31',
    'sensortower_dau',
    'sensortower_revenue',
    'sensortower_download',
    'sensortower_retention',
    'sensortower_D2',
    'sensortower_D3',
    'sensortower_D7',
    'sensortower_D15',
    'sensortower_D31',
  ];
  if (showMetricsItemList.includes(metric)) {
    if (metric.startsWith('appannie_')) {
      return 'data.ai ';
    } else if (metric.startsWith('sensortower_')) {
      return 'Sensor Tower ';
    }
  }
  return '';
}

export const getSumInfo = (entityType:string, formatMessage:Function) => {
  const sumInfoMap = {
    'mobile': 'dbi_info_following_sum_mobile',
    'pc': 'dbi_info_following_sum_pc',
    'console': 'dbi_info_following_sum_console'
  } as any;

  let text = sumInfoMap[entityType] ?? '';
  return text ? formatMessage?.({id:text}) : '';
}


//求平均
export const calAvg = (numbers: number[]) => {
  if (!Array.isArray(numbers) || (!numbers?.length)) return '';
  let validNums = numbers.map(n => Number(n)).filter(n => !isNaN(n)); // 过滤掉 NaN 值 (无效的数字)
  if (!validNums?.length) return '';
  let average = validNums.reduce((total, num) => total + Number(num), 0) / validNums.length;
  return average
}
export const calMax = (numbers: number[]) => {
  if (!Array.isArray(numbers) || (!numbers?.length)) return '';
  let validNums = numbers.map(n => Number(n)).filter(n => !isNaN(n)); // 过滤掉 NaN 值 (无效的数字)
  if (!validNums?.length) return '';
  let max_value = Math.max(...validNums);
  return max_value
}
export const calSum = (numbers: number[]) => {
  if (!Array.isArray(numbers) || (!numbers?.length)) return '';
  let validNums = numbers.map(n => Number(n)).filter(n => !isNaN(n)); // 过滤掉 NaN 值 (无效的数字)
  if (!validNums?.length) return '';
  let sum_of_numbers = validNums.reduce((total, num) => total + num, 0);
  return sum_of_numbers
}


//可视化计算聚合值
export const extractLineMetrics = (seg, data) => {
  if (!Array.isArray(data)) {
    return []
  }
  let numbers: any[] = [];
  // console.log(data)
  data.forEach((t) => {
    const times = t?.times || [];
    times?.forEach(t_item => {
      const metricsList = t_item?.metric_list || [];
      const valueItem = metricsList?.find(
        (item) => createDataSourceMetricForValue(item?.metric, item?.data_source) === seg//'appannie_dau'
      );
      numbers.push(valueItem?.value)
    })
  })
  return numbers

}
export const extractBarMetrics = (seg, data) => {
  if (!Array.isArray(data)) {
    return []
  }
  const numbers = data.map(t => {

    const metrics = t?.metric_list || [];
    const valueItem = metrics.find(
      (item) => createDataSourceMetricForValue(item?.metric, item?.data_source) === seg
    );
    return valueItem?.value;
  });

  return numbers
}

const aggregateNumbers = (numbers, numbers2, metric) => {
  const avgMetrics = [
    'steamcharts_acu',
    'source_steam_source_steam__acu',
    'appannie_D2',
    'appannie_D3',
    'appannie_D7',
    'appannie_D15',
    'appannie_D31',
    'sensortower_D2',
    'sensortower_D3',
    'sensortower_D7',
    'sensortower_D15',
    'sensortower_D31',
  ];
  const maxMetrics = ['steamcharts_pcu', 'source_steam_source_steam__pcu', 'dau'];

  const getAggName = (metric) => {
    return maxMetrics.includes(metric) ? 'Max' :
      avgMetrics.includes(metric) ? 'Avg' : 'Sum';
  }

  const getAggValue = (agg_name, numbers, numbers2) => {
    const isNum1Long = numbers?.length > 0;
    const isNum2Long = numbers2?.length > 0;
    let operationFn = agg_name === "Max" ? calMax :
      agg_name === "Avg" ? calAvg : calSum; // default operation

    if (isNum1Long && isNum2Long) {
      if (agg_name === "Max") {
        //特殊处理Max时只展示一个
        return {
          agg_val: operationFn([operationFn(numbers), operationFn(numbers2)]),
          agg_val2: undefined
        }
      }
      return {
        agg_val: operationFn(numbers),
        agg_val2: operationFn(numbers2)
      }
    } else {
      let validNums = isNum1Long ? numbers : numbers2;
      return {
        agg_val: operationFn(validNums),
        agg_val2: undefined
      }
    }
  }

  const agg_name = getAggName(metric);
  const { agg_val, agg_val2 } = getAggValue(agg_name, numbers, numbers2);
  return { agg_name, agg_val, agg_val2 };
}

const segmentMappings = {
  'dau': ['appannie_dau', 'sensortower_dau'],
  'revenue': ['appannie_revenue', 'sensortower_revenue'],
  'download': ['appannie_download', 'sensortower_download'],
} as any;

export const handleTypeMetrics = (extractMetricsFunction: Function, data, segmentVal, metriceValue) => {
  try {
    const selectedMetrics = segmentMappings[segmentVal] || [];
    let numbers: any[] = [];
    let numbers2: any = [];

    if (selectedMetrics?.length) {
      selectedMetrics.forEach((seg, idx) => {
        if (metriceValue?.includes(seg)) {
          const data2 = extractMetricsFunction(seg, data);
          idx === 0 ? numbers = data2 : numbers2 = data2;
        }
      });
    } else {
      numbers = extractMetricsFunction(segmentVal, data);
    }
    return aggregateNumbers(numbers, numbers2, segmentVal);
  } catch (err) {
    return {}
  }
};
